<template>
   <div class="el-uploadPdf">
      <el-upload class="upload-demo" 
         :limit="1" drag :action="httpUrl" 
         :headers="headers" 
         :before-upload="uploadSc"
         :file-list="listUrl"
         :on-success="uploadBc"
         :on-remove="removeBtn"
         >
         <i class="el-icon-upload"></i>
         <div class="el-upload__text">将文件拖到此处,或 <em>点击上传</em></div>
      </el-upload>
      <div class="prompt">文件格式.pdf、.doc格式，文件大小5M以内</div>
   </div>
</template>
<script>
  import {url,api} from '@/utils/config'
export default {
   name: 'Login',
   data: () => ({
      httpUrl: "",   //请求的url
      headers: {},   //请求头部
      listUrl:[],
      dataVal:[],
   }),
   props:{
      keyVal:{         //关键字
          type: String,
          default: "",
        },
   },
   created(){
      this.setParm()
   },
   methods: {
      //设置初始化的值
      setParm() {
         this.headers = { 'Authorization': localStorage.getItem("YunWeiTikenBRJ") }
         this.httpUrl = url.UPLOADINGMO
         this.listUrl = []
      },
      //上传文件前的校验
      uploadSc(files){
       
         const isRuls =  files.type === 'application/pdf' ||  files.type === 'application/msword';
         const isLt5M = files.size / 1024 / 1024 < 5;
        
         if (!isRuls) {
            this.$message.error('文件只能是PDF,DOC格式!');
         }
         if (!isLt5M) {
            this.$message.error('文件小不能超过5MB!');
         }
         return isRuls && isLt5M;
      }, 

      //上传后的值
      uploadBc(files){
        this.dataVal = [...this.dataVal,...files.data] 
        let parms = {
            key:this.keyVal,
            val:this.dataVal
        }
        this.$emit('getUpload',parms)
      },

      //删除
      removeBtn(file){
         let pdf = ''
         if(!file.response){
             pdf = file.name
         }else{
            pdf = file.response.data[0]
         }
         this.dataVal.splice(this.dataVal.indexOf(pdf),1)
         let parms = {
            key:this.keyVal,
            val:this.dataVal
         }
        this.$emit('getUpload',parms)
      },
      
      //设置值
      setVal(ev){
         //设置默认用于显示
         this.listUrl = ev.listUrl 
         //设置需要传递的值
         this.dataVal = ev.dataVal
      }
     
   }
}
</script>
<style lang="scss" scoped>
.el-uploadPdf {
   position: relative;

   ::v-deep .el-upload-dragger {
      width: 490px;
      height: 150px;
   }

   ::v-deep .el-upload-dragger .el-icon-upload {
      margin: 21px 0 16px;
   }

   ::v-deep .el-upload-list__item:first-child {
      margin-top: -8px
   }

   .prompt {
      position: absolute;
      bottom: -26px;
      color: #606266;
      font-size: 12px;
   }
}
</style>
  